// Generic imports
import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { useFormik } from "formik"
import { toast } from "react-toastify"

// Other components imports
import Button from "components/Button"
import Input from "components/Reusable/Input"
import SelectDay from "components/Reusable/Input/select-day"
import ListJadwal from "components/Class/list-jadwal"

import { createJadwalGroup, editJadwalGroup } from "services/kelas"

const Styles = styled.div`
  .button-add-reset {
    padding-top: 10px;
    padding-bottom: 5px;

    button {
      width: calc(50% - 10px);
      margin: 5px;
    }
  }

  .button-submit-sched {
    button {
      width: 100%;
      margin: 5px;
    }
  }

  .jadwal-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`

const defaultJadwal = {
  hour_start: "07:00:00",
  hour_end: "18:00:00",
  day: "1",
}

export default function JadwalMaker(props) {
  const { kelas, updateKelas, isEdit } = props
  const [loading, setLoading] = useState(false)
  const [schedGroup, setSchedGroup] = useState(-1)
  // -1: Creating a new group, other: Editing an existing group

  const formik = useFormik({
    initialValues: {
      jadwal_group: {
        kelas: kelas.id,
      },
      jadwals: [JSON.parse(JSON.stringify(defaultJadwal))],
    },
    onSubmit: async values => {
      try {
        setLoading(true)
        if (schedGroup < 0) {
          await createJadwalGroup(values.jadwal_group, values.jadwals)
        } else {
          const jadwalGroup = kelas.jadwal_groups[schedGroup]
          await editJadwalGroup(
            values.jadwal_group,
            values.jadwals,
            jadwalGroup.jadwals
          )
        }
        toast.success("Success editing schedule group")
        setTimeout(() => {
          toast.success("Updating schedule maker...")
        }, 2000)
      } catch (e) {
        toast.error(
          e.response.data ? e.response.data : "Please try again later"
        )
      } finally {
        setTimeout(() => {
          updateKelas()
          setLoading(false)
        }, 3000)
      }
    },
  })

  const addNewSchedule = () => {
    formik.setValues({
      jadwal_group: formik.values.jadwal_group,
      jadwals: [
        ...formik.values.jadwals,
        JSON.parse(JSON.stringify(defaultJadwal)),
      ],
    })
  }

  const removeSchedule = index => {
    const oldValues = formik.values
    formik.setValues({
      jadwal_group: oldValues.jadwal_group,
      jadwals: oldValues.jadwals
        .slice(0, index)
        .concat(oldValues.jadwals.slice(index + 1)),
    })
  }

  useEffect(() => {
    const oldValues = formik.values
    formik.setValues({
      jadwal_group: {
        ...oldValues.jadwal_group,
        kelas: kelas.id,
      },
      jadwals: oldValues.jadwals,
    })
  }, [kelas])

  useEffect(() => {
    if (schedGroup < 0) {
      formik.setValues({
        jadwal_group: {
          kelas: kelas.id,
        },
        jadwals: [JSON.parse(JSON.stringify(defaultJadwal))],
      })
    } else {
      const kelasJadwalGroup = kelas.jadwal_groups[schedGroup]
      formik.setValues({
        jadwal_group: {
          kelas: kelas.id,
          pk: kelasJadwalGroup.pk,
        },
        jadwals: [...JSON.parse(JSON.stringify(kelasJadwalGroup.jadwals))],
      })
    }
  }, [schedGroup])

  return (
    <Styles>
      {isEdit ? (
        <div className="schedule-maker">
          <div className="schedule-list">
            {kelas.jadwal_groups && kelas.jadwal_groups.length > 0 ? (
              <ListJadwal
                jadwalGroups={kelas.jadwal_groups}
                clickedJadwal={setSchedGroup}
              />
            ) : (
              <div>You don&apos;t have any schedule group(s)</div>
            )}
          </div>
          <hr style={{ marginBottom: "0" }} />
          <div>
            <h5 style={{ marginTop: "12px", marginBottom: "0" }}>
              {schedGroup < 0
                ? "Create new schedule group"
                : `Edit schedule group number ${schedGroup + 1}`}
            </h5>
            {formik.values.jadwals.map((jadwal, index) => (
              <div key={index}>
                <label className="jadwal-label">
                  <div>Day {index + 1}</div>
                  <Button
                    type="button"
                    className="secondary"
                    onClick={() => removeSchedule(index)}
                  >
                    Remove
                  </Button>
                </label>
                <SelectDay
                  name={`jadwals[${index}].day`}
                  type="text"
                  onChange={formik.handleChange}
                  value={jadwal.day}
                />
                <Input
                  name={`jadwals[${index}].hour_start`}
                  type="time"
                  label="Hour Start"
                  onChange={formik.handleChange}
                  value={jadwal.hour_start}
                />
                <Input
                  name={`jadwals[${index}].hour_end`}
                  type="time"
                  label="Hour End"
                  onChange={formik.handleChange}
                  value={jadwal.hour_end}
                />
                <hr style={{ marginBottom: "0" }} />
              </div>
            ))}
          </div>
          <div className="button-add-reset">
            <Button
              type="button"
              className="secondary"
              onClick={addNewSchedule}
            >
              Add day
            </Button>
            <Button
              type="button"
              className="red"
              onClick={() => setSchedGroup(schedGroup === -1 ? -2 : -1)}
            >
              Reset
            </Button>
          </div>
          <div className="button-submit-sched">
            <Button
              disabled={loading}
              type="button"
              onClick={() => formik.handleSubmit(formik.values)}
            >
              Submit Schedule Group
            </Button>
          </div>
        </div>
      ) : (
        <div style={{ paddingBottom: "12px" }}>
          Schedule maker available after you published the class
        </div>
      )}
    </Styles>
  )
}
